import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../component/img/logo2.png";

import { Menu, ChevronDown, Headphones, PhoneCall, User, Monitor, Send, DollarSign } from "react-feather";
import profileAvatar from "../../../component/img/avatar.png";
import { useNavigate } from "react-router-dom";

const DistributorNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleProfileDropdown = () => setIsProfileDropdownOpen(!isProfileDropdownOpen);


  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("distributor_id");
    localStorage.removeItem("distributor_email");
    console.log("Distributor logged out.");
    navigate("/distributor-login");
  };



  return (
    <>
      <section className="sticky-top hedshdw">
        <nav className="navbar-expand-lg bg-white agentnavbar">
          <div className="container-flui d-flex">
            <Link className="navbar-brand text-white">
              <img src={logo} className="img-fluid logo" alt="Logo" />
            </Link>
            <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <div className="py-2">
                  <span className="me-4">
                    <Link to="/distributor-dashboard">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Dashboard</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/distributor/add-agent" className="menuagent">
                      <span>
                        <Send size={18} />{" "}
                      </span>
                      <span className="menuagent">Create Agent</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/distributor/all-agent" className="menuagent">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Agent Report</span>
                    </Link>
                  </span>
                  {/* <span className="me-4">
                    <Link to="/bus-booking">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Bus</span>
                    </Link>
                  </span> */}
                  <span className="me-4">
                    <Link to="/distributor/transaction-report">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Transaction Report</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/distributor/commission-report">
                      <span>
                        <Monitor size={18} />{" "}
                      </span>
                      <span className="menuagent">Cashback Report</span>
                    </Link>
                  </span>
                  <span className="me-4">
                    <Link to="/state-head/my-wallet">
                      <span>
                        <DollarSign size={18} />{" "}
                      </span>
                      <span className="menuagent">My Wallet</span>
                    </Link>
                  </span>

                  <span className="me-4">
                    <Link to="/state-head/top-up-request">
                      <span>
                        <DollarSign size={18} />{" "}
                      </span>
                      <span className="menuagent">My Request</span>
                    </Link>
                  </span>

                  <span className="me-4">
                    <Link to="/state-head/pin-request">
                      <span>
                        <DollarSign size={18} />{" "}
                      </span>
                      <span className="menuagent">Pin Request</span>
                    </Link>
                  </span>
                  
                 

                </div>
                <li className="nav-item dropdown">
                  <span
                    onClick={toggleProfileDropdown}
                    role="button"
                    className="d-flex align-items-center profile-dropdown"
                  >
                    <img
                      src={profileAvatar}
                      alt="Profile Avatar"
                      className="rounded-circle"
                      style={{ width: "40px", height: "40px" }}
                    />
                    <ChevronDown
                      className="ms-2"
                      aria-expanded={isProfileDropdownOpen ? "true" : "false"}
                    />
                  </span>
                  {isProfileDropdownOpen && (
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link className="dropdown-item" to="/distributor/my-profile">
                          My Account
                        </Link>
                      </li>
                      <li>
                        <span className="dropdown-item" onClick={handleLogout}>
                          Logout
                        </span>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="bg-white"></div>
      </section>
    </>
  );
};

export default DistributorNavbar;
